import { render, staticRenderFns } from "./OktaFactorSettings.vue?vue&type=template&id=71bff7a3&scoped=true"
import script from "./OktaFactorSettings.vue?vue&type=script&lang=ts"
export * from "./OktaFactorSettings.vue?vue&type=script&lang=ts"
import style0 from "./OktaFactorSettings.vue?vue&type=style&index=0&id=71bff7a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71bff7a3",
  null
  
)

export default component.exports